<template>
  <div class="h-100">
    <div class="loader-cont" v-dxloader="isLoader"></div>
    <div class="row h-100" v-show="!isLoader">
      <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
      <div class="breadcrumbs-dark pb-0 pt-4" id="breadcrumbs-wrapper">
        <div class="container">
          <div class="row">
            <div class="col s10 m6 l6 alignLeft">
             <h5 class="card-title alignLeft white-text">{{serviceDetail.name}}</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="col s12" style="height:calc(100% - 45px)">
        <div class="container h-100">
          <div class="section h-100">
            <div class="row m-0 h-100">
              <div class="col s12 m12 l12 h-100">
                <div id="responsive-table" class="card card-default scrollspy h-100" style="overflow:auto">
                  <div class="card-image waves-effect waves-block waves-light">
                    <div class="carousel carousel-slider">
                      <a class="carousel-item" v-for="img in serviceDetail.images" :key="img.id">
                        <img class="activator" :src="img.image" alt>
                      </a>
                    </div>
                  </div>
                  <div class="card-content alignLeft">
                    <span class="card-title activator grey-text text-darken-4">
                        <span class="title-span">{{serviceDetail.name}}</span>
                    </span>
                    <div class="alignLeft pointer more-contents">
                      <div class="service_type">
                        <span>{{serviceDetail.category.name}}</span>
                      </div>
                      <div class="ratings" v-if="serviceDetail.user_reviews && serviceDetail.rating>0">
                          <div class="star-rate">
                            <span>
                                  {{serviceDetail.rating}}
                                  <i class="material-icons">star</i>
                                </span> ({{serviceDetail.user_reviews ? serviceDetail.user_reviews.rating : ""}} ratings) & {{serviceDetail.user_reviews ? serviceDetail.user_reviews.review : ""}} reviews
                          </div>
                      </div>
                      <div class="service_cost">
                        <b>{{serviceDetail.basic_cost.cost}}</b>
                        <span> / {{serviceDetail.basic_cost.value}}</span>
                      </div>
                      <div class="service_duration">
                        <!-- {{serviceDetail.duration}} -->
                        <span>
                            <!-- | -->
                            <i class="material-icons">people</i>
                            <span class="booked">{{serviceDetail.count + ' have booked'}}</span>
                        </span>
                      </div>
                    </div>
                    <hr>
                    <div class="description">
                      <div class="desc_title">
                        <span>Description</span>
                      </div>
                      <p>{{serviceDetail.description}}</p>
                    </div>
                    <hr>
                    <div class="description workorder">
                      <div class="description">
                        <div class="desc_title">
                          <span>Workorder</span>
                        </div>
                        <div class="order-content">
                          <ul class="timeline">
                            <li class="event" v-for="(order,index) in serviceDetail.work_order" :key="order.id" :data-date="'Step ' + (index +1)">
                              <h3>{{order.text}}</h3>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div id="responsive-table" class="card card card-default scrollspy">
                  <div class="card-content">
                    <div class="row">
                      <div class="col s12">
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isLoader : true,
        serviceId: this.$route.params.id,
        serviceDetail: {
          basic_cost: {},
          category : {}
        },
        carouselAutoPlay: {}
      };
    },
    created() {
      this.retrieveService();
    },
    beforeDestroy() {
      clearInterval(this.carouselAutoPlay);
    },
    methods: {
      retrieveService() {
        this.isLoader = true;
        ajax.get(
          Constants.default.APIURL.ServiceDetail + this.serviceId,
          res => {
            this.serviceDetail = res.data;
            this.isLoader = false;
            setTimeout(() => {
              let carousel = $(".carousel").carousel({
                fullWidth: true,
                indicators: true,
                noWrap: false,
                duration: 100
              });
  
              this.carouselAutoPlay = setInterval(() => {
                carousel.carousel("next");
              }, 5000);
            }, 100);
          },
          err => {
            this.isLoader = false;
          }
        );
      }
    }
  };
</script>

<style lang="scss" scoped>
  .carousel {
    height: -webkit-fill-available !important;
    min-height: 300px !important;
    max-height: 500px !important;
  }

  .carousel .carousel-item > img {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
  
  .carousel-item {
    min-height: 300px !important;
    max-height: 500px !important;
  }
  
  .card .card-title {
    font-size: 20px !important;
    margin-bottom: 0 !important;
  }
  
  .title-span {
    font-size: 100% !important;
  }
  
  .add_btn {
    margin-top: 10px;
    margin-right: 10px;
  }
  
  .service_type span {
    background-color: #f4f6f8;
    border-radius: 4px;
    padding: 5px 10px;
    // font-weight: 500;
  }
  
  .inactive {
    opacity: 0.9;
    background: #f9e7e7 !important;
  }
  
  .service_cost {
    // font-weight: 600;
    font-size: 15px;
    padding: 10px 5px 5px 0px;
  }
  
  .service_duration {
    padding: 0px 5px 0px 0px;
    // font-weight: 600;
    font-size: 16px;
    color: #666;
  }
  
  .title-span {
    white-space: nowrap;
    text-overflow: ellipsis;
    width: calc(100% - 30px);
    overflow: hidden;
    display: inline-block;
  }
  
  .desc_title {
    font-size: 16px;
    font-weight: 500;
    color: #919eab;
    margin: 10px 0;
  }
  
  //timeline
  .timeline {
    border-left: 4px solid #545759;
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
    color: rgba(0, 0, 0, 1);
    //   margin: 20px auto;
    margin: 20px 100px;
    letter-spacing: 0.5px;
    position: relative;
    line-height: 1.4em;
    font-size: 1.03em;
    padding: 5px 50px;
    list-style: none;
    text-align: left;
    font-weight: 100;
  }
  
  .timeline h1,
  .timeline h2,
  .timeline h3 {
    letter-spacing: 0.5px;
    font-weight: 400;
    font-size: 16px;
  }
  
  .timeline .event {
    border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
    padding-bottom: 25px;
    margin-bottom: 50px;
    position: relative;
  }
  
  .timeline .event:last-of-type {
    padding-bottom: 0;
    margin-bottom: 0;
    border: none;
  }
  
  .timeline .event:before,
  .timeline .event:after {
    position: absolute;
    display: block;
    top: 0;
  }
  
  .timeline .event:before {
    left: -217.5px;
    color: rgba(0, 0, 0, 0.4);
    content: attr(data-date);
    text-align: right;
    font-weight: 100;
    font-size: 0.9em;
    min-width: 120px;
  }
  
  .timeline .event:after {
    box-shadow: 0 0 0 4px #545759;
    left: -57.85px;
    background: #b9cec9;
    border-radius: 50%;
    height: 11px;
    width: 11px;
    content: "";
    top: 5px;
  }
  
  .service_duration i {
    position: absolute;
  }
  
  .service_duration .booked {
    padding-left: 30px;
    display: inline-block;
  }
  
  .star-rate i {
    float: right;
    font-size: 16px;
    padding-top: 2px;
    padding-left: 2px;
    color: #ffad46;
  }
  
  .ratings {
    font-weight: 500;
    font-size: 15px;
    padding: 12px 0px 0px 0px;
    color: #666;
  }
  
  .star-rate span {
    display: inline-block;
    font-weight: 600;
    color: #000;
  }
  .card .card-image {
    position: relative;
    margin: 27px 25px 0 25px;
    border-radius: 8px;
    overflow: hidden;
  }
</style>

